
import { get, writable } from "svelte/store";
import API from "../../API/API";
import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import MapDataSource from "../../Map/Enums/MapDataSource";
import MapLayer from "../../Map/Enums/MapLayer";
import MapLayerManager from "../../Map/MapLayerManager";
import PopupStore from "../../Map/Popup/PopupStore";
import MapStore from "../../Map/Store";

import MapLayerGroup from "../../Map/Enums/MapLayerGroup";

const SatCapStore = {
	meta: {
		initState: writable(LoadState.INIT),
		loadState: writable(LoadState.INIT),
		chipLoadState: writable(LoadState.INIT),
		opacity: writable(1.0),
		visible: writable(false),
		mapLayersInitted: writable(false)
	},
	results: {
		features: writable([]),
		currentChip: writable("")
	},
	actions: {
		initMap: (map) => {
			if (get(SatCapStore.meta.mapLayersInitted)) {
				return;
			}
			map.addSource(MapDataSource.MDA_SATCAP, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});

			map.addLayer(
				{
					id: MapLayer.MDA_SATCAP,
					source: MapDataSource.MDA_SATCAP,
					type: "circle",
					layout: {
						visibility: "visible"
					},
					paint: {
						"circle-radius": 4,
						"circle-color": ["get", "color"],
						"circle-stroke-color": "rgba(0, 0, 0, 1.0)",
						"circle-stroke-width": 1.0
					}
				}
			);

			MapLayerManager.addLayerGroup(MapLayerGroup.MDA_SATCAP, [MapLayer.MDA_SATCAP], [MapDataSource.MDA_SATCAP]);

			SatCapStore.meta.mapLayersInitted.set(true);
		},
		deinitMap: () => {
			if (!get(SatCapStore.meta.mapLayersInitted)) {
				return;
			}
			MapLayerManager.removeLayerGroup(MapLayerGroup.MDA_SATCAP);
			SatCapStore.meta.mapLayersInitted.set(false);
		},
		init: () => {
			if (get(SatCapStore.meta.loadState) !== LoadState.INIT) {
				const features = get(SatCapStore.results.features);
				const map = MapStore.helpers.getMap();
				map.getSource(MapDataSource.MDA_SATCAP).setData(GeoHelper.emptyGeoJson(features));
				return;
			}

			SatCapStore.meta.loadState.set(LoadState.LOADING);
			console.log("Loading SatCapStore...");

			const onEnterPoint = (e) => {
			    if (e.features.length > 0) {
					const props = e.features[0].properties;
			        const coords = e.features[0].geometry.coordinates;
			        PopupStore.actions.custom(props, coords, true);
				}
			};
			const onLeavePoint = (e) => {
				PopupStore.actions.custom({}, null, false);
			};
			const onClickPoint = (e) => {
				if (e.features.length > 0) {
					const props = e.features[0].properties;
					const id = props.Point_ID;
					console.log("id", id);

					SatCapStore.meta.chipLoadState.set(LoadState.LOADING);
					API.get("sat-cap/latest/image/" + id)
						.then((result) => {
							console.log("result", result);
							SatCapStore.results.currentChip.set(result);
							SatCapStore.meta.chipLoadState.set(LoadState.LOADED);
						})
						.catch((err) => {
							console.error("error", err);
							SatCapStore.meta.chipLoadState.set(LoadState.INIT);
						});
				}
			};

			const map = MapStore.helpers.getMap();
			map.on("click", MapLayer.MDA_SATCAP, onClickPoint);
			map.on("mouseenter", MapLayer.MDA_SATCAP, onEnterPoint);
		    map.on("mousemove", MapLayer.MDA_SATCAP, onEnterPoint);
		    map.on("mouseleave", MapLayer.MDA_SATCAP, onLeavePoint);

			const promises = [API.get("sat-cap/latest")];
			Promise.all(promises)
				.then((responses) => {
					const response = responses[0];

					const features = [];
					for (let i = 0; i < response.length; i++) {
						const lng = response[i].Longitude;
						const lat = response[i].Latitude;

						const props = response[i];
						const keys = Object.keys(props);
						for (let i = 0; i < keys.length; i++) {
							if (props[keys[i]].trim() === "") {
								delete props[keys[i]];
							}
						}
						props.color = "rgba(0, 0, 0, 0.35)";
						if (props.MMSI || props.IMO) {
							props.color = "rgba(0, 255, 0, 0.75)";
						}

						const feature = GeoHelper.featureAt(lng, lat, props);
						features.push(feature);
					}
					features.sort((f1, f2) => {
						return ((typeof f1.MMSI === "undefined") || f1.MMSI <= f2.MMSI) ? -1 : 1;
					});

					const map = MapStore.helpers.getMap();
					map.getSource(MapDataSource.MDA_SATCAP).setData(GeoHelper.emptyGeoJson(features));

					SatCapStore.results.features.set(features);
					SatCapStore.meta.loadState.set(LoadState.LOADED);

					MapLayerManager.updateVisibleLayers();
				})
				.catch((error) => {
					console.error(error);
				});
		}
	}
};

export default SatCapStore;
